<div class="modal-header" #modalHeader tabindex="-1">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa"
       [class.fa-plus-square-o]="minimise"
       [class.fa-minus-square-o]="!minimise"
       role="button"
       tabindex="0"
       [attr.title]="minimise ? 'Restore' : 'Minimize'"
       [attr.aria-label]="minimise ? 'Restore dialog' : 'Minimize dialog'"
       (click)="minimise = !minimise"
       (keydown.enter)="minimise = !minimise"
       (keydown.space)="$event.preventDefault(); minimise = !minimise"></i>
    <i class="fa fa-times"
       role="button"
       tabindex="0"
       title="Close"
       aria-label="Close"
       (click)="cancel()"
       (keydown.enter)="cancel()"
       (keydown.space)="$event.preventDefault(); cancel()"></i>
  </div>
</div>

<div class="modal-body modal-body-alt" [hidden]="minimise">
  <form novalidate>
    <div class="form-row-split">
      <div class="comment-left">
        <label>Comment</label>
        <i class="fa fa-info-circle" title="Public comments will be visible to all users. Private comments are only visible to you and users you have tagged"></i>
        <div class="radio-group">
          <label><input type="radio" name="visibility" value="0" [(ngModel)]="comment.is_public"> Private</label>
          <label><input type="radio" name="visibility" value="1" [(ngModel)]="comment.is_public"> Public</label>
        </div>
        @if (comment.is_public === '1') {
          <div class="all-user-warning">
            Marking 'Public' will allow comment to be visible to all users
          </div>
        }
        <div>
          <label><input type="checkbox" [ngModel]="actionItem.action_item == 1" (ngModelChange)="actionItem.action_item = $event ? 1 : 0" name="action_item"> Action Item</label>
        </div>
        @if (actionItem.action_item) {
          <div>
            <label><input type="checkbox" [(ngModel)]="actionItem.review_meeting" [ngModelOptions]="{standalone: true}" (change)="reviewMeeting()" name="review_meeting"> Review Meeting</label>
          </div>
          <div>
            <label>Target Date</label>
            <input type="date" class="form-control" [(ngModel)]="actionItem.target_date" name="target_date" />
          </div>
        }
      </div>

      <div class="comment-right">
        <label>Subject</label>
        <input type="text" class="form-control" [(ngModel)]="comment.subject" name="subject" [disabled]="!!comment.comment_key" required />
        @if (formSubmitted && !comment.subject?.trim()) {
          <span class="form-error-container">Please add a Subject</span>
        }

        <label>Message</label>
        <textarea class="form-control input-sm" rows="5" [(ngModel)]="comment.message" name="message" placeholder="add message" required></textarea>
        @if (formSubmitted && !comment.message?.trim()) {
          <span class="form-error-container">Please add a message</span>
        }
      </div>
    </div>

    @if (actionItem.action_item) {
      <div class="row-block">
        <label>Tags</label>
        <i class="fa"
           [class.fa-minus-circle]="isShowTag"
           [class.fa-plus-circle]="!isShowTag"
           [class.color-red]="isShowTag"
           [class.color-green]="!isShowTag"
           role="button"
           tabindex="0"
           [attr.title]="isShowTag ? 'Hide add tag' : 'Add tag'"
           [attr.aria-label]="isShowTag ? 'Hide add tag' : 'Add tag'"
           (click)="toggleTagPanel()"
           (keydown.enter)="toggleTagPanel()"
           (keydown.space)="$event.preventDefault(); toggleTagPanel()"></i>
        <div class="well user-well-xs well-xs">
          <select class="form-control" [(ngModel)]="actionItem.action_tag" name="action_tag" (change)="updateTagsTo()">
            <option value="">Select Tag</option>
            @for (opt of tags; track opt.tag_key) {
              <option [ngValue]="opt.tag_key">{{ opt.tag_name }}</option>
            }
          </select>
          @if (actionItem.tags?.length) {
            <div class="tag-chips">
              @for (tag of actionItem.tags; track tag.tag_key; let i = $index) {
                <div class="btn-group btn-group-xs">
                  <span class="btn btn-xs btn-default"><i class="fa fa-tag"></i></span>
                  <span class="btn btn-default btn-xs btn-white">{{ tag.tag_name }}</span>
                  <button type="button" class="btn btn-danger btn-xs" title="Remove tag" [attr.aria-label]="'Remove tag ' + tag.tag_name" (click)="removeTag(i)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (isShowTag) {
      <div class="panel panel-default">
        <div class="panel-heading"><b>Add New Tag:</b></div>
        <div class="panel-body">
          <div class="tag-add-row">
            <input type="text" class="form-control" placeholder="Tag name" [(ngModel)]="tag.tag_name" name="tag_name" />
            <input type="text" class="form-control" placeholder="Tag description" [(ngModel)]="tag.tag_desc" name="tag_desc" />
            <button class="save-button" type="button" (click)="saveTag()" [disabled]="tagCrudLoading">
              @if (tagCrudLoading) {
                <span><i class="fa fa-spinner fa-pulse"></i></span>
              }
              Save
            </button>
            <button class="cancel-button" type="button" (click)="tagCancel()">Cancel</button>
          </div>
        </div>
      </div>
    }

    @if (actionItem.action_item) {
      <div class="row-block">
        <label>Assign Users</label>
        <div class="input-group">
          <input type="text" class="form-control input-sm" placeholder="Type SSO or Last, First"
                 [(ngModel)]="assignUserSearch" name="assignUserSearch" (input)="onAssignUserSearch($event)" />
          <span class="input-group-addon">
            @if (assignUserLoading) {
              <i class="fa fa-spinner fa-pulse"></i>
            } @else {
              <i class="fa fa-search"></i>
            }
          </span>
        </div>
        @if (assignUserResults.length) {
          <div class="search-results">
            @for (user of assignUserResults; track $index) {
              <button type="button" class="btn btn-default btn-xs" (click)="selectAssignUser(user)">
                {{ user.NAME || user.name || user.display_name }}
              </button>
            }
          </div>
        }
        @if (assignNoResults) {
          <div class="btn btn-sm btn-danger">No Results Found</div>
        }
        <div class="well user-well-xs well-xs">
          @for (notify of actionItem.assign; track notify.VALUE; let i = $index) {
            <div class="btn-group btn-group-xs">
              <span class="btn btn-xs btn-default"><i class="fa fa-user"></i></span>
              <span class="btn btn-default btn-xs btn-white">{{ notify.NAME }}</span>
              <button type="button" class="btn btn-danger btn-xs" title="Remove assigned user" [attr.aria-label]="'Remove ' + notify.NAME" (click)="removeAssignUser(i)">
                <i class="fa fa-times"></i>
              </button>
            </div>
          }
        </div>
      </div>
    }

    <div class="row-block">
      <label>Notify Users</label>
      <div class="input-group">
        <input type="text" class="form-control input-sm" placeholder="Type SSO or Last, First"
               [(ngModel)]="notifyUserSearch" name="notifyUserSearch" (input)="onNotifyUserSearch($event)" />
        <span class="input-group-addon">
          @if (notifyUserLoading) {
            <i class="fa fa-spinner fa-pulse"></i>
          } @else {
            <i class="fa fa-search"></i>
          }
        </span>
      </div>
      @if (notifyUserResults.length) {
        <div class="search-results">
          @for (user of notifyUserResults; track $index) {
            <button type="button" class="btn btn-default btn-xs" (click)="selectNotifyUser(user)">
              {{ user.NAME || user.name || user.display_name }}
            </button>
          }
        </div>
      }
      @if (notifyNoResults) {
        <div class="btn btn-sm btn-danger">No Results Found</div>
      }
      <div class="well user-well-xs well-xs">
        @for (notify of comment.notify; track notify.VALUE; let i = $index) {
          <div class="btn-group btn-group-xs">
            <span class="btn btn-xs btn-default"><i class="fa fa-user"></i></span>
            <span class="btn btn-default btn-xs btn-white">{{ notify.NAME }}</span>
            <button type="button" class="btn btn-danger btn-xs" title="Remove notified user" [attr.aria-label]="'Remove ' + notify.NAME" (click)="removeUser(i)">
              <i class="fa fa-times"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <div class="row-block">
      <label>Attachments
        @if (attachmentTO.isError) {
          <span class="form-error-container upload-error">
            Upload failed: Allowed Extensions: jpg, jpeg, png, svg, pdf, xls, xlsx, txt, doc, docx, ico, ppt, pptx, ods, wpd, rtf
          </span>
        }
      </label>
      <div class="attachment-row">
        <div class="well well-xs attach-btn-well">
          <button type="button" class="btn btn-default btn-xs btn-white" title="Add attachment" aria-label="Add attachment" (click)="triggerFileInput()">
            <i class="fa fa-paperclip"></i>
          </button>
          <input type="file" #fileInput (change)="onFileSelected($event)" multiple
                 accept=".jpg,.jpeg,.png,.svg,.pdf,.xls,.xlsx,.txt,.doc,.docx,.ico,.ppt,.pptx,.ods,.wpd,.rtf" />
        </div>
        <div class="well well-xs attachment-list-well">
          @for (file of attachmentTO.attachmented_files; track file) {
            <div class="btn-group btn-group-xs">
              <span class="btn btn-xs btn-default"><i class="fa fa-paperclip"></i></span>
              <span class="btn btn-default btn-xs btn-white attachment-file-name">{{ getAttachmentDisplayName(file) }}</span>
              <button type="button" class="btn btn-danger btn-xs" title="Remove attachment" [attr.aria-label]="'Remove attachment ' + getAttachmentDisplayName(file)" (click)="removeAttachment(file)">
                <i class="fa fa-times"></i>
              </button>
            </div>
          }
        </div>
      </div>
      @for (file of uploadingFiles; track file.name) {
        @if (file.progress < 100) {
          <div>Uploading {{ file.name }} — {{ file.progress }}%</div>
        }
      }
    </div>

    <div class="row-block">
      <div class="well col-sm-12 comment-data-well">Comment Data: {{ cellData }}</div>
    </div>
  </form>
</div>

<div class="modal-footer modal-body-alt" [hidden]="minimise">
  <button class="save-button" type="button" (click)="save()" [disabled]="crudLoading">
    @if (crudLoading) {
      <span><i class="fa fa-spinner fa-pulse"></i></span>
    }
    Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
